import { useState } from 'react';
import PropTypes from 'prop-types';

import { IconCTA, OverlayTriggerTooltip, ShareIcon } from '@utilities';

import ModalShare from '@src/app/pages/Dashboard/components/ModalShare';

const Share = ({
  hasAllColleagues,
  hasException,
  hasFindColleagues,
  hasSharePublicly,
  hideOnMultiSelect,
  isHoverAction,
  isNarrative,
  isSelectedFolders,
  isSelectedItems,
  isSurvey,
  onSubmit,
  selectedRows,
  shareWithClient,
  shareWithUsers,
}) => {
  const [isActive, setIsActive] = useState(false);

  const isSingleSelect = !hideOnMultiSelect || selectedRows?.length === 1;
  const isVisible = !hasException && isSingleSelect;

  if (!isVisible) return null;

  const selectedRowsIds = selectedRows?.map((selectedRow) =>
    isSelectedFolders ? selectedRow?.folderId : selectedRow?.id
  );

  return (
    <>
      <OverlayTriggerTooltip content={isHoverAction ? 'Share' : ''}>
        <IconCTA
          aria-label="Share"
          data-testid="share-cta"
          icon={<ShareIcon />}
          onClick={() => setIsActive(true)}
          text={isHoverAction ? '' : 'Share'}
        />
      </OverlayTriggerTooltip>
      {isActive && (
        <ModalShare
          hasAllColleagues={hasAllColleagues}
          hasFindColleagues={hasFindColleagues}
          hasSharePublicly={hasSharePublicly}
          ids={selectedRowsIds}
          isFolder={isSelectedFolders}
          isNarrative={isNarrative}
          isSurvey={isSurvey}
          onSubmit={() =>
            onSubmit({ refreshFolders: isSelectedFolders, refreshItems: isSelectedItems })
          }
          setShowModalShare={setIsActive}
          shareFoldersWithClients={shareWithClient}
          shareFoldersWithUsers={shareWithUsers}
          shareItemWithClients={shareWithClient}
          shareItemWithUsers={shareWithUsers}
        />
      )}
    </>
  );
};

Share.defaultProps = {
  hasSharePublicly: false,
  hideOnMultiSelect: false,
};

Share.propTypes = {
  hasAllColleagues: PropTypes.bool,
  hasException: PropTypes.bool,
  hasFindColleagues: PropTypes.bool,
  hasSharePublicly: PropTypes.bool,
  hideOnMultiSelect: PropTypes.bool,
  isHoverAction: PropTypes.bool,
  isNarrative: PropTypes.bool,
  isSelectedFolders: PropTypes.bool,
  isSelectedItems: PropTypes.bool,
  isSurvey: PropTypes.bool,
  onSubmit: PropTypes.func,
  selectedRows: PropTypes.array,
  shareWithClient: PropTypes.func,
  shareWithUsers: PropTypes.func,
};

export default Share;
